import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { MenuItem } from 'react-bootstrap';
import logo from '../images/dm-logo.png';

const PROJECT_MENU = "PROJECT_MENU"

class MyNavBar extends Component {
    constructor(props){
        super(props);
        this.state = {
            openMenu : undefined
        }

        this.onMouseClickOutside = this.onMouseClickOutside.bind(this);
        this.onMouseClick = this.onMouseClick.bind(this);
        this.setWrapperRef = this.setWrapperRef.bind(this);
    }

    onMouseClickOutside(event){

        if (this.wrapperRef && this.wrapperRef.contains(event.target)) return
        this.setState({
            openMenu : undefined
        })
    }

    onMouseClick(menu){
        if(menu === this.state.openMenu){
            menu = undefined;
        }
        this.setState({
            openMenu : menu
        })
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }


    componentDidMount() {
        document.addEventListener('mousedown', this.onMouseClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.onMouseClickOutside);
    }

    renderProjectsList() {
        var str = window.location.href;
        var i = str.search("#");
        var j = str.search("\\?");
        var subpage = str.substring(i+2,j)
    	return this.props.projects.map((project, index) => {
    		return (
    			<MenuItem key={project.id} href={`#/${subpage}?project=${project.name}`}><span> {project.name}</span></MenuItem>
    		)
    	})
    }

    render() {
        return (
            <div className="header-section" ref={this.setWrapperRef} style={{height : 60}}>
                <div className="logo dark-logo-bg hidden-* hidden-*">

                    <Link to="/">
                        <img src={logo}  style={{height : 35}} alt=""/>
                        <span className="brand-name">MettleCI</span>
                    </Link>
                </div>
                <div className="icon-logo dark-logo-bg hidden-* hidden-*">
                    <Link to="/">
                        <img src={logo}  style={{height : 30}} alt=""/>
                    </Link>
                </div>


            <div className="navbar-collapse collapse yamm mega-menu">
                <ul className="nav navbar-nav">
                    <li className={ "dropdown" + (this.state.openMenu === PROJECT_MENU? " open" : "")} onClick={() => this.onMouseClick(PROJECT_MENU)}>
                        <a style={{cursor : "pointer", fontSize : 18}}  aria-expanded={this.state.openMenu === PROJECT_MENU}>
                            {this.props.clientName && <strong>{this.props.clientName}</strong> } Project Report Card
                        </a>

                    </li>
                </ul>
            </div>
                <div className="right-notification">
                    <ul className="notification-menu">
                        <li>
                            { this.props.fileName &&
                                <a className="btn btn-default dropdown-toggle">
                                    <strong>File:</strong> {this.props.fileName}
                                </a>
                            }
                        </li>
                        <li>
                            { this.props.date &&
                                <a className="btn btn-default dropdown-toggle">
                                    <strong>Generated:</strong> {this.props.date}
                                </a>
                            }
                        </li>
                    </ul>
                </div>
            </div>);
    }
}

export default MyNavBar;

